import script from "./TextTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextTabs.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__